export const instagram = 'https://www.instagram.com/dimassempre/'
export const facebook = 'https://www.facebook.com/sempre.dimas/'
